import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { stats, teamMembers, faqs } from '@/mocks/news';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        <section className="bg-background-100 py-16 md:py-24">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="flex flex-col lg:flex-row gap-10 md:gap-16 mt-8">
              <div className="lg:w-3/5">
                <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight mb-8">
                  关于每日大赛
                  <br />
                  黑料网
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  每日大赛黑料网创立于2023年，是国内领先的网红娱乐圈爆料资讯平台。我们致力于为广大网友提供最新、最全、最真实的一手爆料内容，涵盖网红塌房、反差视频、八卦内幕、私生活揭秘等热门话题。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  我们的编辑团队由资深娱乐记者、前MCN机构高管和数据分析专家组成，坚持"以事实为依据，以爆料为使命"的核心价值观。每一条信息发布前均经过严格的多方交叉验证，确保内容的真实性和准确性。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  作为行业领先的吃瓜爆料平台，我们秉持客观公正的报道原则，不做任何一方的"枪手"，不发布未经证实的谣言。我们的使命是让每一位"吃瓜群众"都能获取真实可靠的娱乐圈一手资讯。
                </p>

                <div className="grid grid-cols-3 gap-6 mt-12 pt-8 border-t border-background-200/60">
                  {stats.map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="text-2xl md:text-3xl font-heading font-black text-accent-500">
                        {stat.value}<span className="text-lg md:text-xl">{stat.unit}</span>
                      </div>
                      <div className="text-xs md:text-sm text-foreground-600 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:w-2/5">
                <div className="bg-background-200/70 rounded-2xl p-8 md:p-10 h-full flex flex-col justify-center">
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                      <span className="text-sm text-foreground-700 font-label">爆料邮箱</span>
                    </div>
                    <p className="text-base font-medium text-foreground-950 pl-5">hello@mssdp.cn</p>

                    <div className="flex items-center gap-3 mt-6">
                      <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                      <span className="text-sm text-foreground-700 font-label">商务合作</span>
                    </div>
                    <p className="text-base font-medium text-foreground-950 pl-5">hello@mssdp.cn</p>

                    <div className="flex items-center gap-3 mt-6">
                      <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                      <span className="text-sm text-foreground-700 font-label">社交媒体</span>
                    </div>
                    <div className="flex gap-4 pl-5">
                      <a href="http://mssdp.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">微博</a>
                      <a href="http://mssdp.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">微信</a>
                      <a href="http://mssdp.cn/" target="_blank" rel="nofollow noopener noreferrer" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">抖音</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
              <div className="lg:w-[40%] flex-shrink-0">
                <div className="rounded-2xl overflow-hidden aspect-[4/5] bg-background-200">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20investigative%20journalism%20team%20in%20dark%20newsroom%2C%20dramatic%20crimson%20lighting%2C%20serious%20expressions%2C%20editorial%20photography%20style%2C%20cinematic%20mood%2C%20professional%20atmosphere%2C%20dark%20aesthetic&width=800&height=1000&seq=about-team&orientation=portrait"
                    alt="每日大赛黑料网编辑团队"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:w-[60%] flex flex-col justify-center">
                <span className="text-xs font-label text-secondary-400 tracking-widest mb-4">
                  （ 品牌口碑 ）
                </span>
                <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-black leading-tight mb-8">
                  <span className="text-foreground-950">用户信任的</span>
                  <br />
                  <span className="text-secondary-500">吃瓜爆料首选平台</span>
                </h2>
                <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 pl-4 border-l-2 border-primary-500/30">
                  &ldquo;每日大赛黑料网是我每天必刷的平台，他们的爆料不仅速度快，而且准确度极高。好几次他们独家爆出的料，其他媒体几天后才跟进。吃瓜，我只信每日大赛黑料网。&rdquo;
                </blockquote>
                <p className="text-sm font-heading font-bold text-foreground-700">
                  &mdash; 资深吃瓜网友 &ldquo;瓜田守望者&rdquo;
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto mb-14">
              <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-4">
                加入我们
                <br />
                一起搞大事
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
                我们正在寻找优秀的调查记者、内容编辑和数据分析师。如果你对网红娱乐圈有独到的洞察力，欢迎加入每日大赛黑料网。
              </p>
              <a
                href="mailto:hello@mssdp.cn"
                className="inline-flex items-center gap-2 bg-primary-500 text-foreground-950 px-8 py-3.5 rounded-full text-sm font-label font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors duration-200"
              >
                投递简历 <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {teamMembers.map((member) => (
                <div key={member.name} className="bg-background-200/60 rounded-lg p-6">
                  <div className="w-10 h-10 flex items-center justify-center text-accent-500 mb-4">
                    <i className="ri-user-star-line text-2xl"></i>
                  </div>
                  <h3 className="text-base font-heading font-bold text-foreground-950 mb-1">{member.name}</h3>
                  <p className="text-xs text-primary-400 font-label mb-3">{member.role}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="max-w-[1440px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">关于每日大赛黑料网的常见疑问解答</p>
            </div>

            <div className="max-w-3xl mx-auto divide-y divide-background-200/60">
              {faqs.map((faq, index) => (
                <details key={index} className="group py-5">
                  <summary className="flex items-center justify-between cursor-pointer list-none">
                    <h3 className="text-base font-heading font-bold text-foreground-950 pr-4">{faq.question}</h3>
                    <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-500 group-open:rotate-45 transition-transform duration-200">
                      <i className="ri-add-line"></i>
                    </span>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于每日大赛黑料网',
            description: '每日大赛黑料网是国内领先的网红娱乐圈爆料资讯平台，致力于为广大网友提供最新、最全、最真实的一手爆料内容。',
            about: {
              '@type': 'Organization',
              name: '每日大赛黑料网',
              foundingDate: '2023',
              description: '每日大赛黑料网 - 网红大瓜实时追踪，黑料每日更新，吃瓜爆料第一手',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </>
  );
}